import { Link } from 'react-router-dom';
import Footer from '../Footer';


import imgc2 from "../../Assets/the-cut-emerold-img/imgc2of10.jpg?format=webp";
import imgr6of11 from "../../Assets/the-rough-emerold-imgs/imgr6of11.jpg?format=webp"

     

export default function EmeraldSelection() {
       return (
         <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
     
           {/* Hero Section */}
           <section className="py-16 px-6">
             <div className="max-w-7xl mx-auto text-center">
               <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 font-serif">Choose Your Emerald</h1>
               <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                 Select between our exquisite cut emeralds or raw natural treasures. Each piece represents the finest
                 Panjshir quality, handpicked for discerning collectors.
               </p>
             </div>
           </section>
     
           {/* Cards Section */}
           <section className="py-12 px-6">
             <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8">
               {/* Cut Emerald Card */}
               <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                 <div className="aspect-square  flex items-center justify-center p-2">
                   <img src={imgc2} alt="Cut Emerald" className="w-full h-full object-cover" />
                 </div>
                 <div className="p-8">
                   <h2 className="text-3xl font-bold text-gray-900 mb-4 font-serif">Faceted Panjshir Emerald</h2>
                   <p className="text-gray-600 leading-relaxed mb-6">
                     Experience the pinnacle of craftsmanship with our cut Panjshir emeralds. Expertly faceted to unleash
                     vibrant green fire, these gems are sculpted for maximum brilliance and timeless elegance.
                   </p>
                   <ul className="space-y-2 mb-8 text-gray-700">
                     <li className="flex items-start gap-2">
                       <span className="text-emerald-600 mt-1">✓</span>
                       <span>Professionally cut and polished</span>
                     </li>
                     <li className="flex items-start gap-2">
                       <span className="text-emerald-600 mt-1">✓</span>
                       <span>Maximum brilliance and fire</span>
                     </li>
                     <li className="flex items-start gap-2">
                       <span className="text-emerald-600 mt-1">✓</span>
                       <span>Ready for jewelry setting</span>
                     </li>
                     <li className="flex items-start gap-2">
                       <span className="text-emerald-600 mt-1">✓</span>
                       <span>Certified authenticity</span>
                     </li>
                   </ul>
                 <Link to="/shop-cutemerald">
                   <button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-4 rounded-md font-semibold transition-colors flex items-center justify-center gap-2">
                     Select Cut Emerald
                     <span>→</span>
                   </button>
                   </Link>
                 </div>
               </div>
     
               {/* Rough Emerald Card */}
               <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                 <div className="aspect-square  flex items-center justify-center p-2">
                   <img src={imgr6of11} className="w-full h-full object-cover" />
                 </div>
                 <div className="p-8">
                   <h2 className="text-3xl font-bold text-gray-900 mb-4 font-serif">Rough Panjshir Emerald</h2>
                   <p className="text-gray-600 leading-relaxed mb-6">
                     Behold the untamed beauty of raw Panjshir emeralds. Handpicked for their radiant chromium-rich allure,
                     these natural treasures promise timeless elegance and exceptional investment potential.
                   </p>
                   <ul className="space-y-2 mb-8 text-gray-700">
                     <li className="flex items-start gap-2">
                       <span className="text-emerald-600 mt-1">✓</span>
                       <span>Natural uncut specimens</span>
                     </li>
                     <li className="flex items-start gap-2">
                       <span className="text-emerald-600 mt-1">✓</span>
                       <span>Vivid green brilliance</span>
                     </li>
                     <li className="flex items-start gap-2">
                       <span className="text-emerald-600 mt-1">✓</span>
                       <span>Investment grade quality</span>
                     </li>
                     <li className="flex items-start gap-2">
                       <span className="text-emerald-600 mt-1">✓</span>
                       <span>Ethically sourced</span>
                     </li>
                   </ul>
                  <Link to="/shop-roughemerald">
                   <button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-4 rounded-md font-semibold transition-colors flex items-center justify-center gap-2">
                     Select Rough Emerald
                     <span>→</span>
                   </button>
                 </Link>
                 </div>
               </div>
             </div>
           </section>
           <Footer/>
         </div>
       )
     }
     